"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { AppProps } from "next/app";
import { GrowthBookProvider } from "@growthbook/growthbook-react";
import { NextPage } from "next";
import { useRouter } from "next/router";
import NormalLayout from "@/layout/Normal";
import useAuthenticate from "@/hooks/useAuthenticate";
import useGeneralAppState from "@/hooks/useGeneralAppState";
import useGrowthbook from "@/hooks/useGrowthbook";
import { useAppStore } from "@/stores";
import { getGrowthBook, initGrowthbook } from "@/growthbook";
import { useRetentionCookie } from "@/utils/helpers/setRetentionCookie";
import GoogleSignInScriptPagesRouter from "@/components/GoogleSignInScript/GoogleSignInScriptPagesRouter";
import TrackingPagesRouter from "@/components/Tracking/TrackingPagesRouter";

// https://nextjs.org/docs/basic-features/layouts#with-typescript
export type NextPageWithLayout<P = object, IP = P> = NextPage<P, IP> & {
  getLayout?: (page: React.ReactElement) => React.ReactElement;
};
export type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout;
};
initGrowthbook();
function Page(t0) {
  const $ = _c(7);
  const {
    pageProps,
    Component
  } = t0;
  useGrowthbook();
  useGeneralAppState();
  const router = useRouter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getGrowthBook();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const growthbook = t1;
  const {
    generalAppState
  } = useAppStore();
  const shouldAppHydrate = useAuthenticate(!router.isReady || !generalAppState.isGrowthbookLoaded, router.pathname, router.query);
  useRetentionCookie();
  const getLayout = Component.getLayout ?? _temp;
  let t2;
  if ($[1] !== Component || $[2] !== generalAppState || $[3] !== getLayout || $[4] !== pageProps || $[5] !== shouldAppHydrate) {
    t2 = shouldAppHydrate ? getLayout(<GrowthBookProvider growthbook={growthbook}><Component {...pageProps} />{generalAppState.isGrowthbookLoaded && <><GoogleSignInScriptPagesRouter /><TrackingPagesRouter /></>}</GrowthBookProvider>) : null;
    $[1] = Component;
    $[2] = generalAppState;
    $[3] = getLayout;
    $[4] = pageProps;
    $[5] = shouldAppHydrate;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function _temp(page) {
  return <NormalLayout>{page}</NormalLayout>;
}
export default Page;